import { useContext } from 'preact/hooks'
import { AppContext } from '@/js/components/app-context'

export function Icon({ name, className = '' }) {
    const app = useContext(AppContext)

    if (!name) return null
    // Backward compat: raw SVG strings (removable after full migration)
    if (/<svg[\s>]/.test(name)) {
        return <span className={`icon ${className}`} dangerouslySetInnerHTML={{ __html: name }} />
    }
    // Already a full URL
    if (/^(https?:|data:image|blob:|\/\w)/.test(name)) {
        return <img src={name} className={`icon ${className}`} alt="" />
    }
    // Icon name → resolve via app's iconUrl template
    /** @type {string} */
    const src = app.get('iconUrl').replace('__ICON__', name)
    return <img src={src} className={`icon ${className}`} alt="" />
}
